import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'

import { selectQbrSelectedPeriodsWithPercentLabel } from '../../../../features/QBR'
import { TRANSLATION_KEYS } from '../../translations'

import styles from './SelectedPeriodWithPercent.module.scss'

export const SelectedPeriodWithPercent = () => {
  const { quartersLabel, percentage } = useSelector(selectQbrSelectedPeriodsWithPercentLabel)

  if (!quartersLabel) {
    return null
  }

  return (
    <div className={styles.selectPeriodWithPercentRoot}>
      <i className="kbase kbase-info" />
      <div className={styles.selectPeriodWithPercent}>
        <Translation
          span
          text={TRANSLATION_KEYS.financialTable.selectedPeriodWithFQuarters}
          replaceParams={[
            {
              value: quartersLabel,
              key: '{fQuarters}',
            },
            {
              value: percentage === 100 ? '' : String(percentage),
              key: '{percentage}',
            },
          ]}
        />
      </div>
    </div>
  )
}
